const greenhouseQuestionnaire = {
    "title": "溫室生產",
    "sections": [
        {
            "subject": "溫室生產",
            "questions": [
                {
                    "description": "是否有溫室生產",
                    "type": "scq",
                    "options": ["是", "不適用"],
                    "questions": [
                        {
                            "condition": "是",
                            "description": "請提供以下資訊",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["溫室代號", "形式", "面積(平方公尺)", "種植作物", "種在哪裡(土壤/盆栽)", "盆栽的土壤介質成分說明"]
                            }
                        },
                        {
                            "condition": "是",
                            "description": "您用何種灌溉設備",
                            "type": "oeq"
                        },
                        {
                            "condition": "是",
                            "description": "您如何預防種苗病害及蟲害問題?",
                            "type": "oeq"
                        },
                        {
                            "condition": "是",
                            "description": "您如何清洗種苗之容器與設備?",
                            "type": "oeq"
                        },
                        {
                            "condition": "是",
                            "description": "您是否在溫室內同時栽培有機與非有機作物?",
                            "type": "scq",
                            "options": ["是", "否"],
                            "questions": [
                                {
                                    "condition": "是",
                                    "description": "請問種植哪些有機與非有機種苗?若種植相同的有機與非有機作物時(例如:番茄),請列出其品種(例如:黃金品種、黑柿品種)",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "您如何區分有機與非有機之種植區?",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "您如何標示有機與非有機種苗/植株?",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "您如何避免有機及非有機土壤在其混拌及儲存時不會混淆?",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "非有機生產所使用的資材存放哪裡?",
                                    "type": "oeq"
                                },
                                {
                                    "condition": "是",
                                    "description": "您如何防止禁用物質經由通風及/或灌溉系統漂移?",
                                    "type": "oeq"
                                },
                            ]
                        }
                    ]
                }
            ]
        }
    ]
}

export default greenhouseQuestionnaire